// extracted by mini-css-extract-plugin
export default {"content__box":"ContentBox_content__box__rmSJe"};